export const files = [
    <>
        Kalyna farming enterprise <br /> Ternopil region, 2023
    </>,
    <>
        Svitanok LLC <br /> Odesa region, 2023
    </>,
    <>
        Archat LLC <br /> Poltava region, 2023
    </>,
    <>
        Farm "Romax-Agro" <br /> Cherkasy region, 2023
    </>,
    <>
        LLC " Ednist" <br /> Cherkasy region, 2023
    </>,
    <>
        Chorna Kamianka LLC <br /> Cherkasy region, 2020
    </>,
];
